import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import bindAll from 'lodash.bindall';


import style from './checkbox-button.css';

class CheckboxButton extends React.Component {
    constructor (props) {
        super(props);
        bindAll(this, [
            'handleChange'
        ]);
        const {defaultChecked} = this.props;
        this.state = {
            checked: !!defaultChecked
        };
    }
    handleChange (event) {
        this.setState({
            checked: !this.state.checked
        }, () => {
            if (this.props.onChange) this.props.onChange(this.state.checked, event);
        });
    }

    render () {
        const {
            defaultChecked, className, disabled
        } = this.props;
        return (
            <label className={classNames(style.switch, className)}>
                <input
                    type="checkbox"
                    defaultChecked={defaultChecked}
                    onChange={this.handleChange}
                    disabled={disabled}
                />
                <div className={classNames(style.slider, style.round)} />
            </label>
        );
    }
}

CheckboxButton.propTypes = {
    className: PropTypes.string,
    disabled: PropTypes.bool
};

export default CheckboxButton;
